import {RoutePath} from "../../router/routerConfig/routerConfig";

export interface IFooterPage {
  translationKey: string
  path: string | ((lang: string) => string)
  isExternal?: boolean
}

export const footerPages: IFooterPage[] = [
    { translationKey: 'contact', path: RoutePath.contact },
    { translationKey: 'aboutCompany', path: '/' },
    { translationKey: 'specialAbilities', path: '/' },
    { translationKey: 'termsOfUse', path: '/' },
    { translationKey: 'privacyPolicy', path: '/' },
    { translationKey: 'cookiePolicy', path: '/' },
    { translationKey: 'copyrightPolicy', path: '/' },
    { translationKey: 'trademarkPolicy', path: '/' },
    { translationKey: 'communityPolicy', path: '/' },
    { translationKey: 'help', path: '/' },
    { translationKey: 'generalInfo', path: '/' },
    { translationKey: 'press', path: '/' },
    { translationKey: 'blog', path: (lang) => lang === 'en' ? '/blog/' : `/blog/${lang}/`, isExternal: true },
]
